import { TKIconBoldArrowLeft } from "assets/images/svgs";
import NGODashboardLayout from "layout/dashboardlayout/ngodashboardlayout.js";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import InputSelect from "shared/InputSelect";
import SearchField from "shared/Search";
import Table from "shared/Table";

const ProjectDonations = () => {
  const { state } = useLocation();
  const { projectDonations } = useSelector((state) => state.donation);

  const [donationData, setDonationData] = useState(projectDonations);

  const PROJECTDONATIONCOLUMN = [
    {
      name: "ID",
      selector: (row) => row._id,
    },
    {
      name: "Donation Type",
      selector: (row) => row.type,
      cell: (row) =>
        row.type === "money" ? (
          <p
            style={{
              backgroundColor: "#EBFFEB",
              padding: "10px 20px",
              borderRadius: "25px",
              textTransform: "capitalize",
            }}
          >
            {row.type}
          </p>
        ) : row.type === "item" ? (
          <p
            style={{
              backgroundColor: "#F1EEFF",
              padding: "10px 20px",
              borderRadius: "25px",
              textTransform: "capitalize",
            }}
          >
            {row.type}
          </p>
        ) : (
          <p
            style={{
              backgroundColor: "#FFF1E2",
              padding: "10px 20px",
              borderRadius: "25px",
              textTransform: "capitalize",
            }}
          >
            {row.type}
          </p>
        ),
    },
    {
      name: "Donation Date",
      selector: (row) => row.createdAt,
      cell: (row) => <p>{row.createdAt.split("T")[0]}</p>,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      cell: (row) => (row.amount ? <p>N{row.amount}</p> : <p>N/A</p>),
    },
    {
      name: "Item",
      selector: (row) => row.items,
      width: "18rem",
      cell: (row) =>
        row.items.length > 0 ? (
          <div className="flex gap-1">
            {row.items.map((item, idx) => (
              <p className="capitalize" key={idx}>
                {item.split(" ")[0]},
              </p>
            ))}
          </div>
        ) : (
          <p>N/A</p>
        ),
    },
    {
      name: "Payment Method",
      selector: (row) => row.payment_method,
      cell: (row) => (
        <p
          style={{
            textTransform: "capitalize",
          }}
        >
          {row.payment_method}
        </p>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) =>
        row.status === "successful" ? (
          <p className="capitalize" style={{ color: "green" }}>
            {row.status}
          </p>
        ) : row.status === "completed" ? (
          <p className="capitalize" style={{ color: "green" }}>
            {row.status}
          </p>
        ) : row.status === "unsuccessful" ? (
          <p className="capitalize" style={{ color: "red" }}>
            {row.status}
          </p>
        ) : (
          <p className="capitalize" style={{ color: "orange" }}>
            {row.status}
          </p>
        ),
    },
  ];

  const options = [
    {
      title: "All donations",
      value: "",
    },
    {
      title: "Cash donations",
      value: "money",
    },
    {
      title: "Items donations",
      value: "item",
    },
  ];

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  return (
    <NGODashboardLayout section="Project" infoText="Manage your projects">
      <div className="bg-white rounded-md p-6 flex flex-col gap-6">
        <div className="flex flex-col gap-4">
          <div
            onClick={goBack}
            className="flex items-center gap-2 hover:cursor-pointer hover:font-medium"
          >
            <TKIconBoldArrowLeft />
            <p className="text-[#7A7A7A] text-[14px]">Go back</p>
          </div>
          <div className="flex justify-between items-center max-[650px]:flex-wrap gap-4">
            <p className="text-[18px] font-semibold">{state}</p>
            <div className="flex items-center gap-3">
              <SearchField className="flex" placeholder="Search donations" />
              <div className="w-[150px] max-[650px]:w-full">
                <InputSelect
                  onChange={(e) => {
                    if (e.target.value === "") {
                      setDonationData(projectDonations);
                    } else {
                      setDonationData(
                        projectDonations?.filter(
                          (data) => data.type === e.target.value
                        )
                      );
                    }
                  }}
                  options={options}
                />
              </div>
            </div>
          </div>
        </div>
        <Table
          columns={PROJECTDONATIONCOLUMN}
          data={donationData}
          // onRowClicked={(row) => handleSingleInvoice(row.id)}
          selectableRows
          // pointer
          pagination
        />
      </div>
    </NGODashboardLayout>
  );
};

export default ProjectDonations;
